const trans = {
  "Layout & Theme": "التصميم والنمط",
  "Store layout": "تصميم المتجر",
  "Categories view layout": "تصميم الأصناف",
  Customizations: "تخصيصات",
  "Quantity box location": "مكان صندوق الكمية",
  Top: "في الأعلى",
  Bottom: "في الاسفل",
  "Theme color": "لون النمط",
  "Discount tag color": "لون علامة الخصم",
  "(we recommend picking a dark color)": "(نقترح اختيار لون داكن)",
  "Grid view": "شبكة",
  "Grid view minimal": "شبكة مبسطة",
  "List view": "قائمة عمودية",
  "Scroll view": "قائمة افقية",
  "Hide category name": "اخفاء اسم الصنف",
  "Collapse view": "قائمة يمكن تصغيرها",
  "Bubble view": "قائمة مع دوائر",
  Bubbles: "دوائر",
  "Jumbo view": "قائمة جامبو",
  "Image placement": "مكان صورة المنتج",
  Right: "يمين",
  Left: "يسار",
  "Show variants below the product description (only applies if you have variants)":
    "اظهار الانواع اسفل وصف المنتج (سيتم تفعيلها في حال ان لديك انواع فقط)",
  "Show category covers in store front with the category title":
    "عرض صور غلاف الفئات في واجهة المتجر مع عنوان الفئة",
  "Show category covers in category view page and storefront":
    "عرض صور غلاف الفئات في صفحة عرض الفئة و المتجر",
  "Add image in cover column in category page to show":
    "أضف صورة في قسم خلفية الفئة في صفحة الفئات للإظهار ",
  "a cover for category that will show in /category/{your category name} and cover shows in your main store page above the category":
    "غلاف للفئة يظهر في صفحة /category/{اسم الفئة الخاصة بك}، ويظهر الغلاف أيضاً في الصفحة الرئيسية لمتجرك فوق الفئة.",
  'Hide "All" category': 'اخفاء صنف "الجميع"',
  "Make sticky": "يلصق على الشاشة",
  "Make the header fixed to the top of the screen as the customer scrolls.":
    "أبقي القسم في أعلى الشاشة عندما يتنقل العميل في الشاشة",
  "Show one product per row": "عرض منتج واحد في الصف",
  "Hide categories bubbles": "اخفاء دوائر الاصناف",
  "Categories collapsed by default": "تقليص الاصناف تلقائيا",
  "Hide category thumbnails": "إخفاء الصور المصغرة للاصناف",
  None: "بدون",
  Labels: "نصوص",
};

export default trans;
